import { portalProjectsTeamInvitationPath } from "@/app/router/portalRoutes"
import { NotificationTypes, type NotificationDto } from "@/entities/notification/types"

const pickGuidLike = (o: Record<string, unknown>, keys: readonly string[]): string | null => {
  for (const k of keys) {
    const v = o[k]
    if (typeof v === "string" && v.trim()) return v.trim()
  }
  return null
}

/** Возвращает внутренний путь для перехода по клику на уведомление, либо null. */
export const resolveNotificationHref = (n: NotificationDto): string | null => {
  if (n.type !== NotificationTypes.ProjectTeamInvitation) return null
  const raw = n.data
  if (typeof raw !== "object" || raw === null) return null
  const d = raw as Record<string, unknown>
  const projectId = pickGuidLike(d, ["projectId", "ProjectId"])
  const memberId = pickGuidLike(d, ["memberId", "MemberId"])
  if (!projectId || !memberId) return null
  const args = d.args
  const titleFromArgs =
    Array.isArray(args) && typeof args[0] === "string" && args[0].trim() ? args[0].trim() : undefined
  return portalProjectsTeamInvitationPath(projectId, memberId, titleFromArgs)
}
